import {
  Rotationsplan_MitarbeiterByStandortIdsQuery,
  Rotationsplan_MitarbeiterByStandortIdsQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import { MITARBEITER_BY_STANDORT_IDS } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useMitarbeiter/graphql/queries';
import { Standort } from '@/domain/mitarbeiter/features/rotationsplan/entities/Standort';

export function useMitarbeiter(standortIds: string[]): {
  mitarbeiter: Mitarbeiter[];
  error?: string;
} {
  const result = useSuspenseQuery<
    Rotationsplan_MitarbeiterByStandortIdsQuery,
    Rotationsplan_MitarbeiterByStandortIdsQueryVariables
  >(MITARBEITER_BY_STANDORT_IDS, {
    variables: { standortIds: standortIds },
  });

  if (result.error) {
    Sentry.captureException(result.error);
    return { mitarbeiter: [] };
  }

  return {
    mitarbeiter: result.data.mitarbeiter_mitarbeiterByStandortIds.map(
      (mitarbeiter) =>
        new Mitarbeiter({
          id: mitarbeiter.id,
          vorname: mitarbeiter.vorname,
          nachname: mitarbeiter.nachname,
          arbeitnehmerTyp: mitarbeiter.arbeitnehmerTyp ?? undefined,
          imgUrl: mitarbeiter.bildUrl ?? undefined,
          standort: new Standort({
            id: mitarbeiter.standort.id,
            name: mitarbeiter.standort.name,
            storenummer: mitarbeiter.standort.storenummer,
          }),
        }),
    ),
  };
}
